import * as React from 'react';
import {NewsStore, newsStore} from "../../store";
import {Link} from "react-router";
import {DrawText} from "../../components/DrawText";

export class News extends React.Component<any, any> {
    news: NewsStore;
    
    constructor(props: any) {
        super(props);
        this.news = newsStore;
    }
    
    render() {
        const item = this.news.findById("57fd1747212b87c371f5444c");
        const similar = this.news.findSimilar(item);
        
        if (item) {
            return (
                <section className="news">
                    <h1>Новости выставки</h1>
            
                    <div className="latest">
                        <article>
                            <b>{item.date}</b>
                            <h2><Link to={"/news/" + item._id}>{item.title}</Link></h2>
                            <DrawText data={item.preview} />
                            <p><Link to={"/news/" + item._id}>Читать новость полностью</Link></p>
                        </article>
                    </div>
            
                    {similar.length > 0 ? (
                        <div className="similar">
                            <h3>Еще новости по теме:</h3>
                            <ul>
                                {similar.map(item => {
                                    return (
                                        <li key={item._id}>
                                            <Link to={`/news/${item._id}`}>{item.title}</Link>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    ) : ''}
                </section>
            )
        } else {
            return <div />;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./src/route/Sony/News.tsx
 **/